<template>
  <div id="family_manu">
    <v-layout wrap class="pr-4 pl-4 mt-4">
      <v-flex xs12 class="button-container pr-0 text-xs-right">
        <div class="d-inline-flex" v-if="selectedData">
          <v-btn class="pf-btn pf-btn-cancel" @click="reset">
            <v-icon size="16" class="pr-1">cancel</v-icon>
            <div>Cancel</div>
          </v-btn>
          <v-btn class="pf-btn pf-btn-save" @click="save">
            <v-icon size="16" class="pr-1">check_circle</v-icon>
            <div>Save</div>
          </v-btn>
        </div>
      </v-flex>
    </v-layout>
    <!-- <p class="ml-4 mb-5 mt-4 pf-menu-text">Choose the family statuses for each menu items. The menu will be available only for families with the selected statuses</p> -->
    <v-layout class="ml-4 mr-4 flex-column">
      <h3 class="mb-4">1. Family Dashboard</h3>
      <v-layout wrap class="mb-3">
        <v-flex sm1><b class="pf-font-18">#</b></v-flex>
        <v-flex sm4><b class="pf-font-18">Function</b></v-flex>
        <v-flex sm7><b class="pf-font-18">Status</b></v-flex>
      </v-layout>
      <v-layout wrap v-for="(menu, i) in dashboardSettings" :key="i">
        <v-flex sm1 class="flex-align-center pf-menu-text pf-font-18">{{ i + 1 }}</v-flex>
        <v-flex sm4 class="flex-align-center pf-menu-text pf-font-18">{{ menu.title }}</v-flex>
        <v-flex sm7 class="flex-align-center pf-menu-text pf-font-18">
          <v-radio-group v-model="menu.status" row @change="changedData()">
            <v-radio
              v-for="(status, j) in menuStatuses"
              :key="j"
              :label="`${status.text}`"
              :value="status.name"
            ></v-radio>
          </v-radio-group>
        </v-flex>
      </v-layout>
    </v-layout>
    <hr class="mt-5 mb-5">
    <v-layout class="ml-4 mr-4 flex-column">
      <h3 class="mb-4">2. Family Functions</h3>
      <v-layout wrap class="mb-3">
        <v-flex sm1><b class="pf-font-18">#</b></v-flex>
        <v-flex sm4><b class="pf-font-18">Function</b></v-flex>
        <v-flex sm7><b class="pf-font-18">Status</b></v-flex>
      </v-layout>
      <v-layout wrap v-for="(menu, i) in menuSettings" :key="i">
        <v-flex sm1 class="flex-align-center pf-menu-text pf-font-18">{{ i + 1 }}</v-flex>
        <v-flex sm4 class="flex-align-center pf-menu-text pf-font-18">{{ menu.title }}</v-flex>
        <v-flex sm7 class="flex-align-center pf-menu-text pf-font-18">
          <v-radio-group v-model="menu.status" row @change="changedData()">
            <v-radio
              v-for="(status, j) in menuStatuses"
              :key="j"
              :label="`${status.text}`"
              :value="status.name"
            ></v-radio>
          </v-radio-group>
        </v-flex>
      </v-layout>
    </v-layout>
    <v-layout wrap class="pr-4 pl-4 mt-4">
      <v-flex xs12 class="button-container pr-0 text-xs-right">
        <div class="d-inline-flex" v-if="selectedData">
          <v-btn class="pf-btn pf-btn-cancel" @click="reset">
            <v-icon size="16" class="pr-1">cancel</v-icon>
            <div>Cancel</div>
          </v-btn>
          <v-btn class="pf-btn pf-btn-save" @click="save">
            <v-icon size="16" class="pr-1">check_circle</v-icon>
            <div>Save</div>
          </v-btn>
        </div>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
/* global session store  */
import swal from 'sweetalert2';
// import { mapGetters } from 'vuex';
import { getCollection, update } from '../../helpers/helpers';

export default {
  name: 'family_menu',
  // components: {
  // },
  data: () => ({
    menuSettingsBackup: {},
    dashboardSettingsBackup: {},
    selectedData: false,
    menuStatuses: [
      { name: 'on', text: 'On' },
      { name: 'off', text: 'Off' },
      { name: 'on_until_live', text: 'On until live' },
    ],
    adminSettings: null,
    dashboardSettings: [
      {
        name: 'PDFProfile',
        title: 'PDF Profile',
        status: 'on'
      },
      {
        name: 'Flipbook',
        title: 'Flipbook',
        status: 'on'
      },
      {
        name: 'Views',
        title: 'Views',
        status: 'on'
      },
      {
        name: 'WebsiteConfiguration',
        title: 'Website Configuration',
        status: 'on'
      },
      {
        name: 'Files',
        title: 'Files',
        status: 'on'
      },
      {
        name: 'HelpVideos',
        title: 'Help Videos',
        status: 'on'
      },
      {
        name: 'Tasks',
        title: 'Tasks',
        status: 'on'
      },
      {
        name: 'Timeline',
        title: 'Timeline',
        status: 'on'
      },
      {
        name: 'Messages',
        title: 'Messages',
        status: 'on'
      }
    ],
    menuSettings: [
      {
        name: 'Education',
        title: 'Education',
        status: 'on'
      },
      {
        name: 'AboutUs',
        title: 'Parent Info',
        status: 'on'
      },
      {
        name: 'ChildPreferences',
        title: 'Child Preferences',
        status: 'on'
      },
      {
        name: 'ProfileDocuments',
        title: 'Profile Layout',
        status: 'on'
      },
      {
        name: 'Blog',
        title: 'Blog',
        status: 'on'
      },
      {
        name: 'Letters',
        title: 'Letters',
        status: 'on'
      },
      {
        name: 'Albums',
        title: 'Albums',
        status: 'on'
      },
      {
        name: 'Videos',
        title: 'Videos',
        status: 'on'
      },
      {
        name: 'Messages',
        title: 'Messages',
        status: 'on'
      },
      {
        name: 'MyAgencies',
        title: 'My Agencies',
        status: 'on'
      },
      {
        name: 'BMCampaign',
        title: 'Campaign',
        status: 'on'
      },
      {
        name: 'SocialMedia',
        title: 'Social Media',
        status: 'on'
      },
      {
        name: 'FAQ',
        title: 'FAQ',
        status: 'on'
      }
    ]
  }),
  beforeRouteEnter (to, from, next) {
    if (!session.isOnline()) {
      next({ path: '/login' });
    } else {
      next();
    }
  },
  computed: {
    Agency: {
      set (value) {
        store.commit('setAgency', value);
      },
      get () {
        return store.state.Agency;
      }
    }
  },
  async created () {
    window.getApp.$emit('pageSubHeader', 'Family Menu');

    /* Fetch the admin menu settings */
    if (!this.Agency.is_super_admin) {
      await this.fetchAdminMenuSettings();
    }

    if (this.Agency && this.Agency.family_menu_settings && Object.keys(this.Agency.family_menu_settings).length) {
      this.menuSettings = this.Agency.family_menu_settings.menu_settings ? this.Agency.family_menu_settings.menu_settings : this.menuSettings;
      this.dashboardSettings = this.Agency.family_menu_settings.dashboard_settings ? this.Agency.family_menu_settings.dashboard_settings : this.dashboardSettings;
    }
    
    /* Sync with admin menu settings */
    if (!this.Agency.is_super_admin) {
      await this.syncWithAdminMenu();
    } else {
      /* Remove On until live option for admin */
      this.menuStatuses = this.menuStatuses.filter(x => x.name !== 'on_until_live');
    }
    if (this.menuSettings.findIndex(x => x.name === 'Education') === -1) {
      this.menuSettings.splice(1, 0, {
        name: 'Education',
        title: 'Education',
        status: 'on'
      });
    }

    this.menuSettingsBackup = JSON.parse(JSON.stringify(this.menuSettings));
    this.dashboardSettingsBackup = JSON.parse(JSON.stringify(this.dashboardSettings));
  },
  methods: {
    changedData () {
      this.selectedData = true;
    },
    hideButtons () {
      this.selectedData = false;
    },
    reset () {
      this.menuSettings = JSON.parse(JSON.stringify(this.menuSettingsBackup));
      this.dashboardSettings = JSON.parse(JSON.stringify(this.dashboardSettingsBackup));
      this.hideButtons();
    },
    async fetchAdminMenuSettings () {
      if (!this.Agency.is_super_admin) {
        let { error, data, status } = await getCollection('Agency', true, 0, '', { is_super_admin: true }, 'family_menu_settings');
        if (error) {
          console.log('error', error);
          this.snackbar = {
            show: true,
            color: 'red',
            text: 'Failed to fetch the admin data'
          };
        } else {
          data = data && data.length ? data[0] : null;
          if (data && data.family_menu_settings && Object.keys(data.family_menu_settings).length) {
            this.adminSettings = data.family_menu_settings;
          }
        }
      }
    },
    async syncWithAdminMenu () {
      if (!this.Agency.is_super_admin) {
        /* Sync with the admin menu settings */
        let settingKeys = Object.keys(this.adminSettings);
        let variableKeys = {
          menu_settings: 'menuSettings',
          dashboard_settings: 'dashboardSettings'
        };
        for (let h = 0; h < settingKeys.length; h++) {
          let adminSection = this.adminSettings[settingKeys[h]];
          if (!adminSection || !adminSection.length) {
            continue;
          }
          for (let i = 0; i < adminSection.length; i++) {
            let adminSetting = adminSection[i];
            let menuIndex = this[variableKeys[settingKeys[h]]].findIndex(x => x.name === adminSetting.name);
            if (adminSetting) {
              if (menuIndex === -1) {
                /* Add the setting */
                this[variableKeys[settingKeys[h]]].push(adminSetting);
              } else if (adminSetting.status === 'off') {
                /* Remove the setting */
                this[variableKeys[settingKeys[h]]].splice(menuIndex, 1);
              }
            }
          }
        }
      }
    },
    async save () {
      this.selectedData = true;
      if (Object.keys(this.menuSettings).length) {
        this.Agency.family_menu_settings = { menu_settings: this.menuSettings, dashboard_settings: this.dashboardSettings };
      }
      let { error, data, status } = await update('Agency', this.Agency, this.Agency.id);
      if (error) {
        console.log('error', error);
        this.snackbar = {
          show: true,
          color: 'red',
          text: 'Failed to update the data'
        };
      } else {
        swal.fire({
          type: 'success',
          title: 'Family menu settings updated successfully',
          showConfirmButton: false,
          timer: 2500,
          onClose: () => {
            this.hideButtons();
          }
        });
      }
    }
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/Settings/menu.vue